import MutatingIndicator from './MutatingIndicator.vue';

export default MutatingIndicator;
